import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";

class AppointmentService {
  async fetch(page, perPage, search) {
    const pageParam = `page=${page}&perPage=${perPage}`
    let params = search ? `page=${page}&perPage=${perPage}&search=${search}` : pageParam;

    const response = await ajaxService.get(`/appointments?${params}`);
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async viewAppointment(id, page) {
    const response = await ajaxService.get(`/appointments/${id}?page=${page}`);
    if (response ?? false) {
      return response;
    }
  }
  async getScheduleDates(month) {
    const response = await ajaxService.get(
      `/appointment/schedule-dates?yearMonth=${month}`
    );
    if (response ?? false) {
      return response;
    }
  }

  async addAppointment(data) {
    const response = await ajaxService.post(`/appointments`, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async cancelAppointment(data) {
    const response = await ajaxService.post(`/appointments/status`, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async carStatus(id, data) {
    const response = await ajaxService.put(`/appointment/car-status/`, id, data);
    if (response?.success ?? false) {
      return response;
    } else {
      // const errors = response.data.errors;
      const errors = {
        message: ["Method not allowed!"]
      };
      return validationErrors(errors);
    }
  }
  async checkVIN(data) {
    const response = await ajaxService.get(
      `/appointment/vin_number?vin_number=${data}`
    );
    if (response ?? false) {
      return response;
    }
  }
}

const appointmentService = new AppointmentService();

export default appointmentService;
